import { FUEL_MAX, FUEL_STATION_RANGE } from "../constants";
import { wrappedDistance } from "../math/torus";
import type { WorldState } from "../state";

/**
 * Fueling stations (I-026): persistent map objects, never consumed, that top up any ship
 * lingering within FUEL_STATION_RANGE every tick, on top of the fuel rule's thrust/coast
 * burn and regen. A ship in range of more than one station only gets the best rate.
 */
export function applyFuelStations(world: WorldState): void {
	const stations = world.fuelStations;
	if (!stations || !world.rules.fuel || !world.rules.fuelStations) return;
	for (const e of world.entities) {
		if (e.kind !== "ship") continue;
		let best = 0;
		for (const station of stations) {
			if (station.rate <= best) continue;
			if (wrappedDistance(e.pos, station.pos, world.size) <= FUEL_STATION_RANGE)
				best = station.rate;
		}
		if (best > 0) e.fuel = Math.min(FUEL_MAX, e.fuel + best);
	}
}
